import { supabase } from './supabase';
import { toast } from 'react-hot-toast';

export async function updateLastOnline(uid: string): Promise<void> {
  try {
    const { error } = await supabase
      .from('users')
      .update({
        last_login: new Date().toISOString(),
        updated_at: new Date().toISOString()
      })
      .eq('id', uid);

    if (error) throw error;
  } catch (error) {
    console.error('Error updating last online:', error);
  }
}

export async function updateProfile(uid: string, updates: {
  displayName?: string;
  email?: string;
  photoURL?: string;
  preferences?: any;
}): Promise<void> {
  try {
    const { error } = await supabase
      .from('users')
      .update({
        display_name: updates.displayName,
        email: updates.email,
        avatar_url: updates.photoURL,
        preferences: updates.preferences,
        updated_at: new Date().toISOString()
      })
      .eq('id', uid);

    if (error) throw error;
    toast.success('Profile updated successfully');
  } catch (error: any) {
    console.error('Error updating profile:', error);
    toast.error(error.message);
    throw error;
  }
}

export async function updateUserPassword(currentPassword: string, newPassword: string): Promise<void> {
  try {
    const { error } = await supabase.auth.updateUser({
      password: newPassword
    });

    if (error) throw error;
    toast.success('Password updated successfully');
  } catch (error: any) {
    console.error('Error updating password:', error);
    toast.error(error.message);
    throw error;
  }
}

export async function addLocationToUser(uid: string, locationData: any): Promise<void> {
  try {
    const { error } = await supabase
      .from('users')
      .update({
        location_ids: locationData.id,
        updated_at: new Date().toISOString()
      })
      .eq('id', uid);

    if (error) throw error;
    toast.success('Location added successfully');
  } catch (error: any) {
    console.error('Error adding location to user:', error);
    toast.error(error.message);
    throw error;
  }
}

export async function removeLocationFromUser(uid: string, locationId: string): Promise<void> {
  try {
    const { data: user, error: fetchError } = await supabase
      .from('users')
      .select('location_ids')
      .eq('id', uid)
      .single();

    if (fetchError) throw fetchError;

    const updatedLocations = (user.location_ids || []).filter((id: string) => id !== locationId);

    const { error: updateError } = await supabase
      .from('users')
      .update({
        location_ids: updatedLocations,
        updated_at: new Date().toISOString()
      })
      .eq('id', uid);

    if (updateError) throw updateError;
    toast.success('Location removed successfully');
  } catch (error: any) {
    console.error('Error removing location from user:', error);
    toast.error(error.message);
    throw error;
  }
}

export async function updateFacility(facility: any): Promise<void> {
  try {
    const { error } = await supabase
      .from('facilities')
      .update({
        ...facility,
        updated_at: new Date().toISOString()
      })
      .eq('id', facility.id);

    if (error) throw error;
    toast.success('Facility updated successfully');
  } catch (error: any) {
    console.error('Error updating facility:', error);
    toast.error(error.message);
    throw error;
  }
}

export async function updateUserPreferences(uid: string, preferences: any): Promise<void> {
  try {
    const { error } = await supabase
      .from('users')
      .update({
        preferences,
        updated_at: new Date().toISOString()
      })
      .eq('id', uid);

    if (error) throw error;
    toast.success('Preferences updated successfully');
  } catch (error: any) {
    console.error('Error updating preferences:', error);
    toast.error(error.message);
    throw error;
  }
}